

































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  ConstraintSku,
  GameConfigType,
  GameType,
  PlayerType,
  PlayersType,
  TopicPackSku,
  PlayerInfoStringType,
} from "@/types";
import { pluralize } from "@/app/helpers";
import PlayerForm from "@/components/game/PlayerForm.vue";
import PlayerList from "@/components/game/PlayerList.vue";
import PlayerTag from "@/components/game/PlayerTag.vue";
import Engine from "@/app/engine/Engine";
import Constraints from "@/app/engine/constraints/Constraints";
import Packs from "@/app/engine/packs/Packs";

@Component({ components: { PlayerForm, PlayerList, PlayerTag } })
export default class Lobby extends Vue {
  @Prop({ required: true }) config!: GameConfigType;
  @Prop({ required: true }) game!: GameType;
  @Prop({ required: true }) isOwner!: boolean;
  @Prop({ required: true }) player!: PlayerType;
  @Prop({ required: true }) players!: PlayersType;

  bootMode = false;
  showPlayerForm = false;
  showPacksInfo = false;
  showConstraintsInfo = false;

  get bootExtra(): PlayerInfoStringType {
    const res: PlayerInfoStringType = {};
    this.playerIds.forEach((id) => (res[id] = "×"));
    return res;
  }
  get versionExtra(): PlayerInfoStringType {
    const res: PlayerInfoStringType = {};
    this.playerIds.forEach((id) => {
      const v = this.players[id]?.version || "N/A";
      return (res[id] = v === this.player.version ? "✓" : `! ${v}`);
    });
    return res;
  }
  get maxVersion(): string {
    return Object.values(this.players)
      .map((player) => player?.version || "")
      .sort()
      .reverse()[0];
  }

  get canStart(): boolean {
    return this.playerCount >= this.config.minPlayers && this.playerCount < this.config.maxPlayers;
  }

  get constraints() {
    return Constraints.constraintList;
  }

  get gameURL(): string {
    const { origin, pathname, hash } = window.location;
    return `${origin}${pathname}${hash}?game=${this.game.id}`;
  }

  get hasAConstraint() {
    return (
      !this.$root.$data.store.disabledConstraints ||
      this.$root.$data.store.disabledConstraints.length < Object.keys(this.constraints).length
    );
  }

  get messageCantStart(): string | null {
    if (!this.hasAConstraint) {
      return "You need at least one constraint to play.";
    }
    if (this.playerCount < this.config.minPlayers) {
      const remaining = this.config.minPlayers - this.playerCount;
      return `Waiting on ${remaining} ${pluralize("Player", remaining)}.`;
    }
    if (this.playerCount > this.config.maxPlayers) {
      const many = this.playerCount - this.config.maxPlayers;
      return `${many} ${pluralize("Player", many)} too many.`;
    }
    return null;
  }

  get messageRoles(): string {
    const imp = Engine.imposterCount(this.playerCount);
    const agent = this.playerCount - imp;
    return `There will be ${imp} ${pluralize("Imposter", imp)} and ${agent} Agents.`;
  }

  get owner(): PlayerType | null {
    return this.game.players[this.game.ownerId];
  }

  get packs() {
    return Packs.packList;
  }

  get playerCount(): number {
    return this.playerIds.length;
  }

  get playerIds(): string[] {
    return Object.keys(this.players);
  }

  togglePacksInfo() {
    this.showPacksInfo = !this.showPacksInfo;
  }
  toggleConstraintsInfo() {
    this.showConstraintsInfo = !this.showConstraintsInfo;
  }

  handleBoot(id: string) {
    const player = this.game.players[id];
    if (!player) return;
    if (
      window.confirm(
        `Are you sure you want to remove ${player.tag}? If they have the game open, they will automatically rejoin, but they can leave the game from their screen.`
      )
    )
      this.$root.$data.store.gameBoot(id);
  }

  handleLeaveGame() {
    if (window.confirm("Are you sure you want to leave this game?"))
      this.$root.$data.store.gameLeave();
  }

  onPlayerSave(tag: string, color: string) {
    this.showPlayerForm = false;
    this.$root.$data.store.gameUpdatePlayer({ tag, color });
  }
  onPlayerCancel() {
    this.showPlayerForm = false;
  }

  startGame() {
    this.$root.$data.store.roundStart(this.game);
  }

  toggleConstraint(sku: ConstraintSku) {
    this.$root.$data.store.toggleConstraint(sku);
  }
  toggleGalleryMode() {
    this.$root.$data.store.toggleGalleryMode();
  }
  toggleTopic(sku: TopicPackSku) {
    this.$root.$data.store.toggleTopic(sku);
  }
}
